import { render, staticRenderFns } from "./CustomSlider.vue?vue&type=template&id=e15a12b0&scoped=true&"
import script from "./CustomSlider.vue?vue&type=script&lang=js&"
export * from "./CustomSlider.vue?vue&type=script&lang=js&"
import style0 from "./CustomSlider.vue?vue&type=style&index=0&id=e15a12b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e15a12b0",
  null
  
)

export default component.exports